// Place filename here
export const dummyScriptName = '';

// Place file content here
export const dummyScript = `
`;
